import { render, staticRenderFns } from "./OccupancyChart.vue?vue&type=template&id=630c1752"
import script from "./OccupancyChart.vue?vue&type=script&lang=js"
export * from "./OccupancyChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports